























declare var window : any;
import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { SIDE_MENU_ROUTE_MAPPER } from '@/models/configs/RoutersMap';

@Component
export default class TargetRecruitTimesheet extends Vue {
  $toastr: any;

  get isTargetRecruitTimesheetEnabled() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const route = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (route) => SIDE_MENU_ROUTE_MAPPER[route.sectionKey] === '/target-recruit-timesheet',
      );
      return typeof route !== 'undefined';
    }
    const route = vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions.find(
      (item) => item.routerLink === '/target-recruit-timesheet',
    );
    return typeof route !== 'undefined';
  }

  get isTargetRecruitIntegrationPage() {
    return (
      vxm.users.isLoggedIn &&
      this.isTargetRecruitTimesheetEnabled &&
      this.$route.path === '/target-recruit-timesheet'
    );
  }

  async beforeMount() {
    vxm.utility.setSpinnerStatus(true);
  }

  pageLoaded() {
    setTimeout(() => {
      vxm.utility.setSpinnerStatus(false);
    }, 1000);
  }
}
